import { render, staticRenderFns } from "./Eraser.vue?vue&type=template&id=f119a196"
import script from "./Eraser.vue?vue&type=script&lang=js"
export * from "./Eraser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports